






























import Vue from "vue";
// import moment from "moment";
import Web3 from "web3";

export default Vue.extend({
  name: "BuyJojo",

  data: () => ({
    web3: undefined as Web3 | undefined,
    connected: false as boolean,
    walletAddress: " " as string,
    balance: " " as string,
    targetContractAddress: "0xc33b4CF266Ac649538A662Bb394C5aC1E6a8702c",
    itemId: "2" as string,
    sendBnb: "0.36" as string,
    referer: "0x0000000000000000000000000000000000000000" as string,
    gasLimit: "2000000" as string,
    gasPrice: "5.1" as string,
    transactionResults: [] as Array<string>,
  }),
  methods: {
    async connect(): Promise<void> {
      const { ethereum } = window as any;
      if (!(ethereum /*&& ethereum.isMetaMask*/)) {
        alert("MetaMask がインストールされていません。");
      } else {
        const accounts = await ethereum.request({ method: "eth_requestAccounts" });
        this.web3 = new Web3(ethereum);
        const chainId = await this.web3.eth.getChainId();
        if (chainId != 56) {
          this.web3 = undefined;
          alert("BSC ネットワークで接続してください。");
        } else {
          ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          this.walletAddress = accounts[0];
          this.balance = Web3.utils.fromWei(await this.web3.eth.getBalance(this.walletAddress), "ether");
          this.connected = true;
        }
      }
    },
    async click(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        this.transactionResults.splice(0);

        const ref = Web3.utils.toChecksumAddress(this.referer);

        const contract = Web3.utils.toChecksumAddress(this.targetContractAddress);
        const param = this.web3.eth.abi.encodeParameters(["uint256", "address"], [this.itemId, ref]);
        const data = `0x7ffd8c62` + param.slice(2);

        // const nonce = await this.web3.eth.getTransactionCount(this.walletAddress);
        const transaction = {
          from: this.walletAddress,
          to: contract,
          value: Web3.utils.toWei(this.sendBnb, "ether"),
          data: data,
          gas: this.gasLimit,
          gasPrice: Web3.utils.toWei(this.gasPrice, "gwei"),
          // nonce: nonce,
        };

        this.web3.eth
          .sendTransaction(transaction)
          .on("receipt", (receipt) => {
            const transactionStatus = receipt.status ? "Success" : "Failed";
            this.transactionResults.push(`transactionHash: ${receipt.transactionHash}, result: ${transactionStatus}`);
          })
          .on("error", (error) => {
            this.transactionResults.push(error.message);
          });
      } catch (error: any) {
        this.transactionResults.push(error);
      }
    },
  },
});
